import { CONSTANTS } from '@exchange/libs/utils/constants/src';

export const ONBOARDING_VERIFICATION_STATUS_URL = `${process.env.VUE_APP_ACCOUNTS_URL}${CONSTANTS.ONBOARDING_PATHNAME}/verification/status`;
